import { useEffect } from "react";
import { trpc } from "../../lib/trpc.js";
import { obterSocket } from "../../lib/socket.js";

/**
 * Um lote, acompanhado enquanto anda.
 *
 * Mesmo desenho de `useGeracao`: o socket é conveniência e o polling é a
 * garantia. A diferença é o que se observa — aqui são quarenta itens mudando de
 * estado em ordem imprevisível, e o que interessa é o agregado ficar correto,
 * não cada transição chegar.
 *
 * O polling é mais espaçado que o do atendimento (8 s contra 4 s) porque
 * ninguém está parado na frente desta tela esperando uma foto específica: o
 * operador abre o lote, sai, e volta depois.
 */
export function useLote(loteId: string | undefined) {
  const utils = trpc.useUtils();

  const consulta = trpc.lotes.getById.useQuery(
    { loteId: loteId ?? "" },
    {
      enabled: loteId !== undefined,
      refetchInterval: (q) => (q.state.data?.resumo.concluido === false ? 8_000 : false),
    },
  );

  useEffect(() => {
    if (loteId === undefined) return;

    const socket = obterSocket();
    const recarregar = () => void utils.lotes.getById.invalidate({ loteId });

    // O socket é broadcast global: o filtro por lote é aqui, como o filtro por
    // geração é no atendimento.
    const aoMudarLote = (e: { loteId: string }) => {
      if (e.loteId === loteId) recarregar();
    };

    socket.on("lote:updated", aoMudarLote);

    return () => {
      socket.off("lote:updated", aoMudarLote);
    };
  }, [loteId, utils]);

  return {
    lote: consulta.data,
    carregando: consulta.isLoading,
    erro: consulta.isError ? consulta.error.message : null,
    recarregar: () => void consulta.refetch(),
  };
}
